// extracted by mini-css-extract-plugin
export default {"wrapper":"MarkdownViewer_wrapper__zZPJn"};